export let UJ_OUTCOME = /*#__PURE__*/function (UJ_OUTCOME) {
  UJ_OUTCOME["SUCCEEDED"] = "SUCCEEDED";
  UJ_OUTCOME["USER_CANCELED"] = "USER_CANCELED";
  UJ_OUTCOME["FAILED"] = "FAILED";
  return UJ_OUTCOME;
}({});